import cn from "classnames";
import { Field } from "react-final-form";
import { Space, InputRef } from "antd";
import {
  InstagramOutlined,
  GlobalOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import {

  ErrorField,
  FloatingLabelInput,
  Icon,
} from "~/components";
import { PayformLinkType, NamesOfFieldEnum } from "~/typings/types";
import {
  composeValidators,
  disabledValidate,
  validateSingleUrlInput,
  validateUrl,
} from "~/utils";
import styles from "./SocialFieldInput.module.scss";
import { ERROR_FIELD_ } from "~/configs/consts";
import { RenderError } from "~/components/error-field";

export const configPlatform: Record<
  PayformLinkType,
  { title: string; icon: React.ReactNode }
> = {
  [NamesOfFieldEnum.PayformLinkVk]: {
    title: "ВКонтакте",
    icon: <Icon name="vk" className={cn(styles.iconSocial, styles.iconVk)} />,
  },
  [NamesOfFieldEnum.PayformLinkTg]: {
    title: "Telegram",
    icon: <Icon name="tg" className={cn(styles.iconSocial)} />,
  },
  [NamesOfFieldEnum.PayformLinkInstagram]: {
    title: "Instagram*",
    icon: <InstagramOutlined className={cn(styles.iconSocial)} />,
  },
  [NamesOfFieldEnum.PayformLinkSite]: {
    title: "Сайт",
    icon: <GlobalOutlined className={cn(styles.iconSocial, styles.iconSite)} />,
  },
  [NamesOfFieldEnum.PayformLinkOther]: {
    title: "Другое",
    icon: <AppstoreOutlined className={cn(styles.iconSocial, styles.iconOther)} />,
  },
};

export const SocialFieldInput = ({
  platform,
  renderError,
  onClear,
}: {
  platform: PayformLinkType;
  renderError?: RenderError;
  onClear: any;
}) => (
  <div className={styles.socialFieldRow}>
    <Field
      name={platform}
      subscription={{
        value: true,
        error: true,
        submitError: true,
        submitFailed: true,
      }}
    >
      {({ input, meta: { error, submitError, submitFailed } }) => {
        const hasError = (error || submitError) && submitFailed;
        const inputId = hasError ? `${ERROR_FIELD_ + input.name}` : undefined;

        return (
          <div className={styles.inputWrapper}>
            <Space>{configPlatform[platform].icon}</Space>
            <FloatingLabelInput
              {...input}
              id={inputId}
              className={cn(styles.inputCustom, {
                [styles.inputCustomError]: hasError,
              })}
              titleField={`Введите ссылку для ${configPlatform[platform].title}`}
              style={{ flex: 1 }}
            />
            {input.value && (
              <span
                className={styles.clearIcon}
                onClick={onClear}
              >
                ×
              </span>
            )}
          </div>
        );
      }}
    </Field>
    <ErrorField name={platform} renderError={renderError} />
  </div>
);